/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Modal,
} from 'antd';
import {
} from '@ant-design/icons';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import { onError } from 'utils/handlers';

import NumericInput from 'components/NumericInput';
import {
  deleteMercanciaDecomiso, getMercanciasDecomisos, patchMercanciaDecomiso, postMercanciaDecomiso,
} from 'api/recaudacion/mercanciaDecomisos';

export const modelCrud = 'mercanciadecomiso';

const MercanciaDecomisos = ({ multa, permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    if (multa) {
      const _data = await getMercanciasDecomisos({ multa });
      setData(_data);
    }

    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;

    const fetchAll = async () => {
      setLoading(true);
      const [_data] = await Promise.all([
        getMercanciasDecomisos({ multa }),
      ]);
      if (mounted) {
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
  };

  const onClickEdit = () => {
    setVisible(true);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      values.multa = multa;
      const saved = await (key ? patchMercanciaDecomiso(key, values)
        : postMercanciaDecomiso(values));
      if (saved) {
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteMercanciaDecomiso(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
    setLoading(false);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 150,
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 200,
    },
    {
      titleText: 'Unidad de Mercancia',
      dataIndex: 'unidad_mercancia',
      key: 'unidad_mercancia',
      width: 200,
    },
    {
      titleText: 'Cantidad',
      dataIndex: 'cantidad',
      key: 'cantidad',
      width: 200,
    },
  ];

  const rules = {
    required: [
      { required: true },
    ],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          mobileColumns={[columns[0], columns[1]]}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit,
            onClickDelete,
          }}
          rowKey="id"
          pagination={false}
          permission={permission}
        />
        <Col span={24} style={{ height: '100%' }}>
          <Modal
            visible={visible}
            closable={false}
            footer={null}
            maskClosable={!loading}
            keyboard={!loading}
            title={(

              <FormSubmitControls
                label="Añadir Mercancia"
                onFinish={onFinish}
                onCancel={onCancel}
              />
      )}
            onCancel={onCancel}
            forceRender
            centered
          >
            <Form
              name="general"
              layout="vertical"
              form={form}
              onFinish={() => onFinish()}
              scrollToFirstError
            >
              <Row gutter={10}>
                <Col span={24}>
                  <Form.Item
                    name="clave"
                    rules={rules.required}
                    label="Clave"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="descripcion"
                    rules={rules.required}
                    label="Descripcion"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="unidad_mercancia"
                    rules={rules.required}
                    label="Unidad Mercancia"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <NumericInput
                    name="cantidad"
                    label="Cantidad"
                    hasFeedback
                    decimal
                    required
                  />
                </Col>
              </Row>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
        </Col>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          visible={visibleAlert}
          content="Concepto de Anuncio"
          loading={loading}
        />
      </Spin>
    </Row>
  );
};
MercanciaDecomisos.propTypes = {
  multa: PropTypes.number,
  permission: PropTypes.shape({
    add: PropTypes.bool.isRequired,
    authorize: PropTypes.bool.isRequired,
    cancel: PropTypes.bool.isRequired,
    change: PropTypes.bool.isRequired,
    delete: PropTypes.bool.isRequired,
    export: PropTypes.bool.isRequired,
    import: PropTypes.bool.isRequired,
    sync: PropTypes.bool.isRequired,
    view: PropTypes.bool.isRequired,
  }).isRequired,
};

MercanciaDecomisos.defaultProps = {
  multa: null,
};

export default MercanciaDecomisos;
